export default __webpack_public_path__ + "static/media/healthTrophy.a7f4e319.svg";